import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../theme/color-palette';
import { BOGLE_REGULAR } from '../../../constants/constant';

export const useStyles = makeStyles(() => ({
	dataRefresh: {
		borderRadius: '20px !important',
		color: colors.FONT_COLOR,
		fontFamily: BOGLE_REGULAR,
		fontSize: '14px !important',
		backgroundColor: colors.LIGHT_GRAY_SHADE,
		padding: '5px 16px',
		'@media (max-width: 1300px)': {
			width: '98% !important',
			marginBottom: '1%',
		},
	},
}));
